import {
  IStyles,
  IconWrapper,
  InputField,
  InstructionsPanel,
  Loader,
  PrimaryButton,
  TimePicker,
  deserify,
  getLocalStorage,
  pxToRem,
  pxTovW,
  useCommonServiceClientContext,
  theme,
  MultiSelect,
  ToggleSwitch,
  QuantityButtonV2,
} from '@geneo2-web/shared-ui';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import {
  Box,
  FormControl,
  FormControlLabel,
  Grid,
  Popper,
  Radio,
  RadioGroup,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { Question } from '@protos/content_management/content.db_pb';
import {
  AssignmentConfigEnum,
  AssignmentInfo,
  MarkingSchemeEnum,
  ModeOfConductionEnum,
  TaskEnum,
} from '@protos/learning_management/lms.db_pb';
import { MouseEvent, ReactNode, useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useGlobalContext } from '../../../../app/Context/GlobalContextProvider';
import {
  useAppDispatch,
  useAppSelector,
} from '../../../../reduxStore/reduxHooks';

import {
  calculateMinMaxTime,
  combineStartTimeAndDate,
  convertTimeStringToTimestamp,
  getModeOfConductionString,
} from '../../../../utils/functions';
import { useAttendanceFeatureEnabled } from '../../../../utils/customHooks';
import { interactionEvent } from '../../../Auth/auth.events';
import { setToastInfo } from '../../../Home/reducer/homeDashboard.slice';

import {
  resetAssessmentInstructions,
  setCreatedAssessmentDetails,
  setAssessmentInstructions,
  setTemporarySectionIds,
  resetCustomHomework,
} from '../../reducer/assessmentFlow.slice';
import { HomeworkInstructionsPopup } from './components/HomeworkInstructions';
import { aiHomeworkCreateEvent } from '../../../Homework/homework.events';
import {
  ASSESSMENT_CONGRATULATIONS,
  DIAGNOSTIC,
  FORMATIVE,
  // HOMEWORK_CONGRATULATIONS,
} from '../../../../routeHandling/RoutesNomenclature';
import { PartialMessage, Timestamp } from '@bufbuild/protobuf';

import {
  AssessmentAssignmentSubmitResponse,
  SectionStudent,
} from '@protos/learning_management/lms.assessment.teacher.apis_pb';
import { useDownloadContext } from '../../../../app/Context/DownloadContextProviderV2';
import { getAssessmentTypeName } from '../ReviewAssessment/functions';
import {
  getConductionCapabilities,
  getMaxSets,
  resolveModeOfConduction,
  useCurrentMinute,
  wrongEndTime,
  wrongStartTime,
} from '../../utils/assessment.utils';
import { StartAndEndPointPicker } from './components/StartAndEndPointPicker';
import { ArrowRightIcon } from '@mui/x-date-pickers';
import { StudentListPopup } from './components/StudentListPopup';
import { ClickerTimedToggle } from './components/ClickerTimedToggle';
import { calculateTotalTime } from '@geneo2-web/shared-ui';

const styles: IStyles = {
  root: {
    width: '100vw',
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: { xs: pxToRem(20), lg: pxTovW(241) },
    paddingRight: { xs: pxToRem(20), lg: pxTovW(241) },
    paddingTop: { xs: pxToRem(20), lg: pxTovW(40) },
    paddingBottom: { xs: pxToRem(20), lg: pxTovW(40) },
    boxSizing: 'border-box',
    overflowX: 'hidden',
  },
  header: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: { xs: pxToRem(20), md: pxTovW(40) },
  },
  inputFeildBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: pxToRem(20), md: pxTovW(40) },
    width: { xs: '100%', md: pxTovW(856) },
    // backgroundColor: 'blue',
    mb: '2.343vw', //32px
  },
  instructionBox: {
    width: { xs: '100%' },
    // boarder: '1px solid #CCE6FE',
    boxSizing: 'border-box',
    marginTop: { xs: '30px', sm: '30px', md: 0 },
  },
  instructionCard: {
    display: 'flex',
    flexDirection: 'column',
    padding: { xs: pxToRem(14), lg: pxTovW(10) },
    boxSizing: 'border-box',
    paddingBottom: { xs: pxToRem(14), md: pxTovW(47) },
    borderRadius: { xs: pxToRem(10), md: pxTovW(15) },
    width: { xs: '100%' },
    backgroundColor: '#F6FBFF',
    border: '1px solid #CCE6FE',
    gap: { xs: pxToRem(20), md: pxTovW(16) },
    marginBottom: { xs: pxToRem(60) },
    // backgroundColor: 'blue',
  },
  textBox: {
    display: 'flex',
    // alignItems: 'center',
    width: '100%',
    paddingLeft: { md: pxTovW(10) },
    paddingRight: { md: pxTovW(10) },
    gap: { xs: pxToRem(6.61), md: pxTovW(6.61) },
    // paddingTop: '20px',
    alignItems: 'flex-start',
  },
  inputField: {
    // backgroundColor: "red",
    height: { xs: pxToRem(50), md: pxTovW(70) },
    borderRadius: { xs: pxToRem(10), md: pxTovW(15) },
    border: '1px solid #CCE6FE',
    width: { xs: '100%', md: pxTovW(856) },
    justifyContent: 'center',
  },
  timeFeild: {
    height: { xs: pxToRem(50), md: pxTovW(70) },
    borderRadius: { xs: pxToRem(10), md: pxTovW(15) },
    border: '1px solid #CCE6FE',
    width: { xs: pxToRem(145), md: pxTovW(200) },
    alignItems: 'center',
    justifyContent: 'center',
  },
  reminderFeild: {
    width: { xs: pxToRem(311), md: pxTovW(419) },
    height: { xs: pxToRem(50), md: pxTovW(70) },
    borderRadius: { xs: pxToRem(10), md: pxTovW(15) },
    border: '1px solid #CCE6FE',
    // alignItems: 'center',
    justifyContent: 'center',
  },
  inputBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: pxToRem(10), md: pxTovW(10) },
  },
  labelTypo: {
    fontSize: { xs: pxToRem(20), md: pxTovW(25), lg: pxTovW(18) },
  },

  multySelect: {
    height: { xs: pxToRem(60), md: pxTovW(70) },
    borderRadius: { xs: pxToRem(10), md: pxTovW(15) },
    border: '1px solid #CCE6FE',

    justifyContent: 'center',
  },
  labelToggle: {
    fontSize: { xs: '1.4rem', sm: '1.4rem', md: '0.8rem', lg: '1rem' },
  },
};

interface IDataList {
  name: string;
  id: bigint;
  selected: boolean;
}
interface IHomeworkData {
  taskName: string;
  dailyReminder: string;
  allowLateSubmission: boolean;
  duration: string;
  shufflingAllowed: boolean;
  reattemptAllowed: boolean;
  timeTest: boolean;
}
export const AssignAssessment = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const [studentListPopupOpen, setStudentListPopupOpen] = useState(false);
  const pathname = location.pathname;
  const assessmentName = getAssessmentTypeName(pathname);
  const isFormativeORDiagnosticAssessment = (): boolean =>
    assessmentName === 'DIAGNOSTIC' || assessmentName === 'FORMATIVE';

  const pathSegments = location.pathname.split('/');
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isIpad = useMediaQuery(theme.breakpoints.down('lg'));
  const CustomHw = true;
  const { isOffline } = useDownloadContext();
  const { user_info } = deserify(useAppSelector((state) => state.auth));
  const isAttendanceFeatureEnabled = useAttendanceFeatureEnabled();
  const minute = useCurrentMinute();
  const [isAllStudentsSelected, setIsAllStudentsSelected] = useState(true);

  const { manage_mode_of_conduction } = deserify(
    useAppSelector((state) => state.manageHomework)
  );
  const { class_subject_info } = deserify(
    useAppSelector((state) => state.homeDashboard)
  );
  // const {
  //   fetched_hw_details,
  //   submitted_hw_id,
  //   module_filtered_questions,
  //   questions_count,
  //   homework_instructions,
  //   custom_homework,
  // } = deserify(useAppSelector((state) => state.homework));
  const {
    fetched_assessment_details,
    submitted_assessment_id,
    module_filtered_questions,
    questions_count,
    assessment_instructions,
    custom_homework,
    assesment_creation_type,
    fa_format_details,
  } = deserify(useAppSelector((state) => state.assessment));

  const { LmsAssessmentTeacherAPIServiceV2WithStatusCodeHandler } =
    useCommonServiceClientContext();

  const { setSelectedFunction } = useGlobalContext();
  const [clickerTimedType, setClickerTimedType] = useState<
    'default' | 'custom'
  >('default');
  const [selectedPreDefinedTime, setSelectedPreDefinedTime] =
    useState<string>('1 minute');
  const [customDefinedTime, setCustomDefinedTime] = useState<{
    minutes: number;
    seconds: number;
  }>({ minutes: 0, seconds: 30 });
  const [sectionStudentInfo, setSectionStudentInfo] = useState<
    SectionStudent[]
  >([]);
  const [openInstructionsPopup, setOpenInstructionsPopup] = useState(false);
  const [loading, setLoading] = useState<'loading' | 'completed' | 'error'>(
    'completed'
  );
  const [noOfSets, setNoOfSets] = useState<number>(1);
  const [sectionList, setSectionList] = useState<IDataList[]>(
    // exampleSectionList
    user_info?.teachClassSubjects
      ?.filter((elem) => {
        const modeOfConduction =
          assesment_creation_type?.creationType === 'Readymade'
            ? manage_mode_of_conduction
            : assesment_creation_type?.modeOfConduction;
        if (
          modeOfConduction ===
          ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_CLICKER
        ) {
          return (
            class_subject_info?.classId === elem.classId &&
            elem.isClickerSupported === true
          );
        } else {
          return class_subject_info?.classId === elem.classId;
        }
      })
      .map((elem) => {
        const isFormativeAssessment = location.pathname.includes(FORMATIVE);
        const preselectedSectionId = isFormativeAssessment
          ? fa_format_details?.selectedSection?.id ||
            class_subject_info?.sectionId
          : class_subject_info?.sectionId;
        return {
          id: elem.sectionId,
          name: elem.sectionName,
          selected: preselectedSectionId === elem.sectionId ? true : false,
        };
      }) || []
  );

  const [toggleAssignmentInfoList, setToggleAssignmentInfoList] = useState<
    PartialMessage<AssignmentInfo>[]
  >(() => {
    return initialToggleData.map((item) => {
      if (item.configName === AssignmentConfigEnum.ASSIGNMENT_CONFIG_TIMED) {
        return {
          ...item,
          isEnabled: isFormativeORDiagnosticAssessment()
            ? true
            : item.isEnabled,
        };
      }
      return item; // Return all other items unchanged
    });
  });

  // ------------------------------------------------------------

  const checkToggle = (config: AssignmentConfigEnum) => {
    const toggleInfo = toggleAssignmentInfoList.find(
      (toggleData) => toggleData.configName === config
    );
    return toggleInfo?.isEnabled ? toggleInfo?.isEnabled : false;
  };

  // ------------------------------------------------------------

  const handleToggleSwitch = (config: AssignmentConfigEnum) => {
    setToggleAssignmentInfoList((prevState) =>
      prevState.map((data) =>
        data.configName === config
          ? { ...data, isEnabled: !data.isEnabled }
          : data
      )
    );
  };

  // ------------------------------------------------------------

  const [homeworkData, setHomeworkData] = useState<IHomeworkData>({
    // taskName: fetched_hw_details?.homeworkTitle || '',
    taskName: assesment_creation_type?.assessmentName || '',
    dailyReminder: '18:00',
    allowLateSubmission: false,
    duration: isFormativeORDiagnosticAssessment() ? '50' : '',
    shufflingAllowed: checkToggle(
      AssignmentConfigEnum.ASSIGNMENT_CONFIG_SHUFFLING
    ),
    reattemptAllowed: checkToggle(
      AssignmentConfigEnum.ASSIGNMENT_CONFIG_REATTEMPT
    ),
    timeTest: checkToggle(AssignmentConfigEnum.ASSIGNMENT_CONFIG_TIMED),
  });
  const [startTimeValues, setStartTimeValues] = useState({
    timeValue: `${new Date().getHours()} : ${new Date().getMinutes()}`,
    dateValue: new Date(
      Date.now() - new Date().getTimezoneOffset() * 60000
    ).toISOString(), // Includes timezone offset
  });
  const [endTimeValues, setEndTimeValues] = useState({
    timeValue: '23:59',
    dateValue: new Date(
      Date.now() - new Date().getTimezoneOffset() * 60000
    ).toISOString(),
  });

  const teacher_id = deserify(getLocalStorage('userId'));

  // ------------------------------------------------------------
  const backButtonClick = async () => {
    dispatch(resetAssessmentInstructions());
    if (!custom_homework) {
      navigate(-1);
    }
  };

  useEffect(() => {
    setSelectedFunction(() => backButtonClick);
    return () => {
      setSelectedFunction(null);
    };
  }, []);

  // ------------------------------------------------------------

  // console.log('toggleAssignmentInfoList', toggleAssignmentInfoList);
  // useEffect(() => {
  //   //making all config false by default for Clicker Assessments
  //   const modeOfConduction =
  //     assesment_creation_type?.creationType === 'Readymade'
  //       ? manage_mode_of_conduction
  //       : assesment_creation_type?.modeOfConduction;

  //   const isClicker =
  //     modeOfConduction ===
  //     ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_CLICKER;

  //   const updatedToggleData = initialToggleData.map((item) => ({
  //     ...item,
  //     isEnabled: isClicker ? false : item.isEnabled,
  //   }));

  //   setToggleAssignmentInfoList(updatedToggleData);
  // }, [assesment_creation_type.modeOfConduction, manage_mode_of_conduction]);

  // ------------------------------------------------------------

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;

    // Prevent invalid numeric input for duration (no negatives or zero)
    if (name === 'duration') {
      // Allow empty value so user can clear input
      if (value === '') {
        setHomeworkData({ ...homeworkData, [name]: value });
        return;
      }

      const numericValue = Number(value);
      if (numericValue > 0) {
        setHomeworkData({ ...homeworkData, [name]: value });
      }
      return;
    }

    setHomeworkData({ ...homeworkData, [name]: value });
    console.log('form....', name, '---', value);
  };

  // ------------------------------------------------------------

  const assignClickHandler = () => {
    if (
      startTimeValues.timeValue !== '' &&
      startTimeValues.dateValue !== '' &&
      endTimeValues.dateValue !== '' &&
      endTimeValues.timeValue !== ''
    ) {
      const currentTimeIsoString = new Date().toISOString();
      //if start time smaller than current Time make current Time as start Time
      const startTimeIsoString =
        currentTimeIsoString > combineStartTimeAndDate(startTimeValues)
          ? currentTimeIsoString
          : combineStartTimeAndDate(startTimeValues);

      const endTimeIsoString = combineStartTimeAndDate(endTimeValues);
      const startTime = new Date(startTimeIsoString);
      const endTime = new Date(endTimeIsoString);
      // const date = new Date();
      // const currentTime = new Date(
      //   Math.floor(date.getTime() / 300000) * 300000
      // );
      if (endTime < new Date(Date.now())) {
        dispatch(
          setToastInfo({
            variant: 'error',
            label: 'Assessment  deadline has passed.',
            open: true,
          })
        );
      }
      // else if (startTime < currentTime) {
      //   console.log({ starttime: startTime, currentTime: currentTime });
      //   dispatch(
      //     setToastInfo({
      //       variant: 'error',
      //       label: 'Start date and time has already passed',
      //       open: true,
      //     })
      //   );
      // }
      else if (startTime > endTime) {
        dispatch(
          setToastInfo({
            variant: 'error',
            label: 'Start date connot be after End date',
            open: true,
          })
        );
      } else if (startTime.toString() === endTime.toString()) {
        dispatch(
          setToastInfo({
            variant: 'error',
            label: 'Start date and time cannot be same as End date and time',
            open: true,
          })
        );
      } else if (homeworkData.taskName === '') {
        dispatch(
          setToastInfo({
            variant: 'error',
            label: 'Assessment  Name Cannot be empty',
            open: true,
          })
        );
      }
      // else if (homeworkData.duration === '') {
      //   dispatch(
      //     setToastInfo({
      //       variant: 'error',
      //       label: 'Duration Cannot be empty',
      //       open: true,
      //     })
      //   );
      // }
      else {
        assignmentSubmission({ startTime: startTime, endTime: endTime });
        // console.log({ starttime: startTime, currentTime: currentTime });
        // console.log(startTime, endTime);
      }
    } else {
      dispatch(
        setToastInfo({
          variant: 'error',
          label: 'Please select all Date and Time',
          open: true,
        })
      );
    }
  };

  // ------------------------------------------------------------

  const getDefaultQuestionTimeInSec = () => {
    if (clickerTimedType === 'default') {
      const timeArr = selectedPreDefinedTime.split(' ');
      const timeValue = Number(timeArr[0]);
      const timeUnit = timeArr[1]?.toLowerCase();

      if (timeUnit === 'seconds') {
        return timeValue;
      } else if (timeUnit === 'minute' || timeUnit === 'minutes') {
        return timeValue * 60;
      } else {
        // Fallback: assume minutes if unit is unrecognized
        return timeValue * 60;
      }
    } else {
      return customDefinedTime.minutes * 60 + customDefinedTime.seconds;
    }
  };

  // ------------------------------------------------------------

  interface ISubmissionProps {
    startTime: Date;
    endTime: Date;
  }
  const assignmentSubmission = async (props: ISubmissionProps) => {
    const { endTime, startTime } = props;
    try {
      setLoading('loading');
      const startTimeIsoString = combineStartTimeAndDate(startTimeValues);
      const endTimeIsoString = combineStartTimeAndDate(endTimeValues);

      const assessmentSubmitPayload = {
        assessmentName: homeworkData.taskName,
        // assignmentInfo: toggleAssignmentInfoList,
        assignmentInfo: toggleAssignmentInfoList.filter((item) => {
          //sending only those configs which are enabled and supported by the mode of conduction
          switch (item.configName) {
            case AssignmentConfigEnum.ASSIGNMENT_CONFIG_TIMED:
              return conductionConfig.configs.timed;

            case AssignmentConfigEnum.ASSIGNMENT_CONFIG_REATTEMPT:
              return conductionConfig.configs.reattempt;

            case AssignmentConfigEnum.ASSIGNMENT_CONFIG_SHUFFLING:
              return conductionConfig.configs.shuffling;

            case AssignmentConfigEnum.ASSIGNMENT_CONFIG_PROCTORING:
              return conductionConfig.configs.proctoring;

            case AssignmentConfigEnum.ASSIGNMENT_CONFIG_QUESTION_BASED_TIMER:
              return conductionConfig.configs.questionBasedTimer;

            default:
              return true;
          }
        }),
        dailyReminderTime: convertTimeStringToTimestamp(
          homeworkData.dailyReminder
        ),
        endTime: Timestamp.fromDate(endTime),
        sectionIds: isAllStudentsSelected
          ? sectionList.filter((val) => val.selected).map((val) => val.id)
          : [...new Set(sectionStudentInfo.map((val) => val.sectionId))],
        startTime: Timestamp.fromDate(startTime),
        teacherId: teacher_id,
        timeDurationInMin:
          conductionConfig.configs.timed &&
          checkToggle(AssignmentConfigEnum.ASSIGNMENT_CONFIG_TIMED)
            ? Number(homeworkData.duration)
            : undefined,
        sectionStudentsInfo: isAllStudentsSelected
          ? undefined
          : sectionStudentInfo,
      };

      // let response: TeacherHWAssignmentSubmitResponse | null = null;
      let assessmentResponse: AssessmentAssignmentSubmitResponse | null = null;
      if (custom_homework?.taskType === TaskEnum.TASK_HOMEWORK_TEACHER_CUSTOM) {
        assessmentResponse =
          await LmsAssessmentTeacherAPIServiceV2WithStatusCodeHandler.assessmentAssignmentSubmit(
            {
              ...assessmentSubmitPayload,
              assessmentId: custom_homework.assessmentId,
              assessmentInstructions: custom_homework.assessmentInstructions,
            }
          );
      } else {
        assessmentResponse =
          await LmsAssessmentTeacherAPIServiceV2WithStatusCodeHandler.assessmentAssignmentSubmit(
            {
              ...assessmentSubmitPayload,
              assessmentId: submitted_assessment_id,
              // modeOfConduction: fetched_assessment_details?.modeOfConduction
              //   ? fetched_assessment_details?.modeOfConduction
              //   : assesment_creation_type?.modeOfConduction,
              modeOfConduction:
                assesment_creation_type?.creationType === 'Readymade'
                  ? manage_mode_of_conduction
                  : assesment_creation_type.modeOfConduction,
              assessmentInstructions: assessment_instructions,
              markingSchemeType:
                assesment_creation_type.markingScheme ??
                MarkingSchemeEnum.MARKING_SCHEME_GENEO,
              // marksPerQuestion: assesment_creation_type.marksPerQuestion,
              numberOfSet: conductionConfig.features.noOfSets
                ? noOfSets
                : undefined,
              defaultQuestionTimeInSec:
                conductionConfig.configs.questionBasedTimer &&
                checkToggle(
                  AssignmentConfigEnum.ASSIGNMENT_CONFIG_QUESTION_BASED_TIMER
                )
                  ? getDefaultQuestionTimeInSec()
                  : undefined,
            }
          );
      }
      if (assessmentResponse?.data) {
        setLoading('completed');
        // dispatch(setCreatedHWDetails(response.data?.updatedHW));
        dispatch(setCreatedAssessmentDetails(assessmentResponse.data));
        dispatch(
          setTemporarySectionIds(
            sectionList.filter((val) => val.selected).map((val) => val.id)
          )
        );

        const questionInfoArray = module_filtered_questions?.questions?.map(
          (que: any) => {
            return {
              questionId: que.questionId,
              difficultyLevel: que.questionMeta.difficultyLevel,
            };
          }
        );

        const [hours, minutes] = homeworkData.dailyReminder
          .split(':')
          .map(Number);
        const reminderTime = new Date();
        reminderTime.setHours(hours);
        reminderTime.setMinutes(minutes);

        await aiHomeworkCreateEvent({
          homeworkId: submitted_assessment_id,
          name: homeworkData.taskName,
          estimateTime: Number(timeOfQuestions()),
          questionInfo: questionInfoArray,
          noOfQuestions: module_filtered_questions?.questions.length,
          marks: totalMarks(module_filtered_questions?.questions),
          // startTimestamp: Timestamp.fromDate(new Date(startTimeIsoString)),
          startTimestamp: new Date(startTimeIsoString),
          // endTimestamp: Timestamp.fromDate(new Date(endTimeIsoString)),
          endTimestamp: new Date(endTimeIsoString),
          allowLateSubmission: homeworkData.allowLateSubmission,
          // dailyRemainder: convertTimeStringToTimestamp(
          //   homeworkData.dailyReminder
          // ),
          dailyRemainder: reminderTime,
          isOffline: isOffline,
        });

        dispatch(resetAssessmentInstructions());
        dispatch(resetCustomHomework());
        navigate(
          `${ASSESSMENT_CONGRATULATIONS}/${assessmentResponse.data.updatedAssessment?.assessmentId}`
        );

        await interactionEvent({
          context: 'assign_homework',
          name: 'ASSIGN',
          pathSegments: pathSegments,
          isOffline: isOffline,
        });
      }
    } catch (err: any) {
      setLoading('error');
      dispatch(
        setToastInfo({
          label: `${
            err.message
              ? err.message.replace(/.*\]\s*/, '').trim()
              : 'Assign homework Failed'
          }`,
          variant: 'error',
          open: true,
        })
      );
      console.log(err);
    }
  };

  // ------------------------------------------------------------

  const timeOfQuestions = () => {
    if (module_filtered_questions?.questions?.length) {
      const totalTime = calculateTotalTime(module_filtered_questions.questions);
      return totalTime.toString();
    }
    return `${calculateMinMaxTime(questions_count).min}-${
      calculateMinMaxTime(questions_count).max
    }`;
  };

  // ------------------------------------------------------------

  const totalMarks = (question?: Question[]) => {
    if (!question) {
      return 0;
    }
    const marks = question.reduce(
      (acc, curr) =>
        acc +
        (curr.question?.model.value?.commonQuestionContent?.marks[0] || 0),
      0
    );
    return marks;
  };

  // ------------------------------------------------------------

  let mobileCssToggle: object = {};

  if (isMobile) {
    mobileCssToggle = {
      display: 'flex',
      alignItems: 'center',
      textAlign: 'right',
      marginTop: '10px',
      flexDirection: 'row',
    };
  } else {
    mobileCssToggle = { alignItems: 'center', marginTop: '10px', flex: 1 };
  }

  // ------------------------------------------------------------

  const modeSelected = resolveModeOfConduction({
    creationType: assesment_creation_type?.creationType,
    manageMode: manage_mode_of_conduction,
    assessmentMode: assesment_creation_type?.modeOfConduction,
  });

  const conductionConfig = useMemo(() => {
    return getConductionCapabilities(modeSelected);
  }, [modeSelected]);

  // ------------------------------------------------------------

  const isProctoringEnabled = true; // temporary variable

  const totalQuestions =
    questions_count.noOfHighQuestions +
    questions_count.noOfMediumQuestions +
    questions_count.noOfLowQuestions;

  const maxPossibleSets = getMaxSets(totalQuestions || 1);

  // ------------------------------------------------------------

  return loading === 'loading' ? (
    <Loader />
  ) : (
    <Box sx={styles.root}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Box sx={styles.header}>
          <Typography variant="h1">
            {assessmentName === 'DIAGNOSTIC'
              ? `Assign Diagnostic Assessment`
              : assessmentName === 'FORMATIVE'
              ? `Assign Formative Assessment`
              : `Assign Daily Assessment`}
          </Typography>
          <Typography
            variant="cardText"
            sx={{ color: '#007CDC', fontWeight: 'normal', marginTop: '10px' }}
          >
            Class {class_subject_info?.classname || ''}
            {sectionList.find((s) => s.selected)?.name ||
              class_subject_info?.section ||
              ''}{' '}
            | {class_subject_info?.subject || ''}
          </Typography>
        </Box>
        <PrimaryButton
          key={`assign_${minute}`}
          disabled={
            wrongStartTime({ startTimeValues }).wrongDate ||
            wrongStartTime({ startTimeValues }).wrongTime ||
            wrongEndTime({ startTimeValues, endTimeValues }).wrongDate ||
            wrongEndTime({ startTimeValues, endTimeValues }).wrongTime ||
            (!isAllStudentsSelected && sectionStudentInfo.length === 0) ||
            sectionList.filter((val) => val.selected).length === 0
          }
          onClick={assignClickHandler}
          sx={{ display: { xs: 'none', md: 'unset' } }}
        >
          ASSIGN
        </PrimaryButton>
      </Box>

      <Box
        sx={{
          boxSizing: 'border-box',
          // paddingLeft: { xs: pxToRem(20), md: pxTovW(40) },
          // paddingRight: { xs: pxToRem(20), md: pxTovW(40) },
          display: { md: 'flex' },
          gap: { xs: pxToRem(10), md: pxTovW(36) },
        }}
      >
        <Box sx={styles.inputFeildBox}>
          {class_subject_info?.isClickerSupported ? (
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                gap: { xs: pxToRem(10), md: pxTovW(20) },
                mb: { xs: pxToRem(20), md: pxTovW(40) },
              }}
            >
              <Typography variant="h3" fontWeight="bold">
                Conduction Via
              </Typography>
              <Box
                sx={{ display: 'flex', gap: pxTovW(10), alignItems: 'center' }}
              >
                <IconWrapper
                  name={
                    modeSelected ===
                    ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_CLICKER
                      ? 'clicker_icon'
                      : modeSelected ===
                        ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_OMR
                      ? 'omr'
                      : 'mobile-app'
                  }
                  type="png"
                  parentFolder="icons"
                  customSx={{
                    width: { xs: pxToRem(20), md: pxTovW(35) },
                    height: { xs: pxToRem(40), md: pxTovW(42) },
                  }}
                />
                <Typography variant="h4" fontWeight="bold">
                  {getModeOfConductionString(
                    assesment_creation_type?.creationType === 'Readymade'
                      ? manage_mode_of_conduction
                      : assesment_creation_type?.modeOfConduction
                  )}
                </Typography>
              </Box>
            </Box>
          ) : null}
          <Box sx={styles.inputBox}>
            {conductionConfig.meta.isClicker ? (
              <Typography variant="h3" sx={styles.labelTypo}>
                Clicker Assessment Name
              </Typography>
            ) : (
              <Typography variant="h3" sx={styles.labelTypo}>
                Assessment Name
              </Typography>
            )}
            <InputField
              nonCircular
              value={homeworkData.taskName}
              name="taskName"
              onChange={handleChange}
              variant="outlined"
              sx={styles.inputField}
            />
          </Box>

          <StartAndEndPointPicker
            startTimeValues={startTimeValues}
            setStartTimeValues={setStartTimeValues}
            endTimeValues={endTimeValues}
            setEndTimeValues={setEndTimeValues}
          />

          <Box
            sx={{
              display: 'flex',
              justifyContent: { xs: 'space-between', md: 'flex-start' },
              gap: { md: pxTovW(27) },
              flexDirection: { xs: 'column-reverse', md: 'row' },
            }}
          >
            <Box
              sx={{
                ...styles.inputBox,
                width: { md: pxTovW(409) },
                flexGrow: { xs: '1', md: '0' },
              }}
            >
              <Typography variant="h3" sx={styles.labelTypo}>
                Daily Reminder
              </Typography>
              <Box>
                <TimePicker
                  fullWidth
                  value={homeworkData.dailyReminder}
                  name="dailyReminder"
                  handleTimeChange={(time) => {
                    setHomeworkData((prev) => ({
                      ...prev,
                      dailyReminder: time,
                    }));
                  }}
                />
              </Box>
            </Box>

            {conductionConfig.features.noOfSets ? (
              <Box
                sx={{
                  ...styles.inputBox,
                  width: { md: pxTovW(409) },
                  flexGrow: { xs: '1', md: '0' },
                }}
              >
                <Typography variant="h3" sx={styles.labelTypo}>
                  No. of Sets
                </Typography>
                <Box>
                  <QuantityButtonV2
                    value={noOfSets}
                    max={maxPossibleSets}
                    // disabled={maxQuantityFromSelectedTypes === 0}
                    onChange={async (nextValue: number) => {
                      setNoOfSets(nextValue);
                    }}
                    onIncrement={async () => {
                      setNoOfSets((prev) =>
                        Math.min(prev + 1, maxPossibleSets)
                      );
                    }}
                    onDecrement={async () => {
                      setNoOfSets((prev) => Math.max(prev - 1, 1));
                    }}
                  />
                </Box>
              </Box>
            ) : null}

            {custom_homework?.taskType !==
              TaskEnum.TASK_HOMEWORK_TEACHER_CUSTOM &&
            conductionConfig.configs.timed ? (
              <Box
                sx={{
                  ...styles.inputBox,
                  width: { md: pxTovW(409) },
                  flexGrow: { xs: '1', md: '0' },
                }}
              >
                <Typography
                  variant="h3"
                  sx={styles.labelTypo}
                >{`Duration (Min)`}</Typography>{' '}
                {!checkToggle(AssignmentConfigEnum.ASSIGNMENT_CONFIG_TIMED) ? (
                  <Box
                    sx={{
                      height: { xs: pxToRem(55), md: pxTovW(64) },
                      borderRadius: { xs: pxToRem(10), md: pxTovW(10) },
                      backgroundColor: '#F2F2F2',
                    }}
                  ></Box>
                ) : (
                  <InputField
                    value={homeworkData.duration}
                    name="duration"
                    onWheel={(e) => {
                      e.preventDefault();
                      (e.target as HTMLElement).blur();
                    }}
                    inputProps={{
                      min: 1,
                      inputMode: 'numeric',
                    }}
                    onChange={handleChange}
                    variant="outlined"
                    nonCircular
                    type="number"
                    autoComplete="off"
                    onKeyDown={(evt) => {
                      let checkIfNum = false;
                      if (evt.key !== undefined) {
                        checkIfNum =
                          evt.key === 'e' ||
                          evt.key === '.' ||
                          evt.key === '+' ||
                          evt.key === '-' ||
                          evt.key === 'Subtract' ||
                          evt.key === 'ArrowUp' ||
                          evt.key === 'ArrowDown';
                      }
                      return checkIfNum && evt.preventDefault();
                    }}
                    sx={{
                      borderRadius: { xs: pxToRem(0.8), md: pxTovW(0.8) },
                      '& input[type=number]': {
                        '-moz-appearance': 'textfield',
                        '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button':
                          {
                            '-webkit-appearance': 'none',
                            margin: 0,
                          },
                      },
                    }}
                  />
                )}
              </Box>
            ) : null}
          </Box>

          {conductionConfig.features.chooseSection ? (
            <Box
              sx={{
                display: 'flex',
                justifyContent: { xs: 'space-between', md: 'flex-start' },
                gap: { md: pxTovW(27) },
                flexDirection: { xs: 'column-reverse', md: 'row' },
              }}
            >
              <Box
                sx={{
                  ...styles.inputBox,
                  width: { md: pxTovW(409) },
                  flexGrow: { xs: '1', md: '0' },
                }}
              >
                <Typography variant="h3" sx={styles.labelTypo}>
                  Choose Section
                </Typography>
                <MultiSelect
                  selectAllTitle="All Divisions"
                  inputName="homeworkSection"
                  handleChange={handleChange}
                  dataList={sectionList}
                  setDataList={setSectionList}
                />
              </Box>
              {conductionConfig.meta.isClicker ? null : (
                <Box
                  sx={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingTop: { xs: 0, md: pxTovW(24) },
                    // backgroundColor: 'red',
                  }}
                >
                  <FormControl
                    sx={{
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <RadioGroup
                      row
                      aria-labelledby="choose-state-radio-group-label"
                      name="choose-state-radio-group"
                      sx={{
                        display: 'flex',
                      }}
                    >
                      <FormControlLabel
                        value={'Approve for all section'}
                        control={
                          <Radio
                            checked={isAllStudentsSelected}
                            onClick={() => setIsAllStudentsSelected(true)}
                          />
                        }
                        label={
                          <Typography
                            variant="h2"
                            sx={{
                              color: isAllStudentsSelected ? '#007CDC' : '#000',
                              fontSize: { xs: pxToRem(18), md: pxTovW(21) },
                            }}
                          >
                            All Students
                          </Typography>
                        }
                      />
                      <FormControlLabel
                        value={``}
                        control={
                          <Radio
                            checked={!isAllStudentsSelected}
                            onClick={() => setIsAllStudentsSelected(false)}
                          />
                        }
                        label={
                          <Box
                            sx={{ display: 'flex', alignItems: 'center' }}
                            onClick={() => setStudentListPopupOpen(true)}
                          >
                            <Typography
                              variant="h2"
                              sx={{
                                color: !isAllStudentsSelected
                                  ? '#007CDC'
                                  : '#000',
                                textDecoration: !isAllStudentsSelected
                                  ? 'underline'
                                  : 'none',
                                fontSize: { xs: pxToRem(18), md: pxTovW(21) },
                              }}
                            >
                              Select Specific Students{' '}
                              {!isAllStudentsSelected &&
                              sectionStudentInfo.length
                                ? `(${sectionStudentInfo.length})`
                                : ''}
                            </Typography>
                            <ArrowRightIcon
                              sx={{
                                color: !isAllStudentsSelected
                                  ? '#007CDC'
                                  : '#000',
                                fontSize: { xs: pxToRem(18), md: pxTovW(21) },
                              }}
                            />
                          </Box>
                        }
                      />
                    </RadioGroup>
                  </FormControl>
                </Box>
              )}
              {custom_homework?.taskType ===
              TaskEnum.TASK_HOMEWORK_TEACHER_CUSTOM ? (
                <Box
                  sx={{ ...mobileCssToggle, paddingLeft: { md: pxTovW(100) } }}
                >
                  <Box>
                    <Typography variant="bodyText" sx={styles.labelToggle}>
                      Reattempt
                    </Typography>
                  </Box>

                  <Box sx={{ marginLeft: 'auto' }}>
                    <ToggleSwitch
                      checked={checkToggle(
                        AssignmentConfigEnum.ASSIGNMENT_CONFIG_REATTEMPT
                      )}
                      handleChange={() =>
                        handleToggleSwitch(
                          AssignmentConfigEnum.ASSIGNMENT_CONFIG_REATTEMPT
                        )
                      }
                    />
                  </Box>
                </Box>
              ) : null}
            </Box>
          ) : null}

          {custom_homework?.taskType !==
          TaskEnum.TASK_HOMEWORK_TEACHER_CUSTOM ? (
            <Grid container>
              {conductionConfig.configs.shuffling ? (
                <Grid item xs={12} md={6} lg={4}>
                  <LocalToggle
                    label="Question Shuffling"
                    checked={checkToggle(
                      AssignmentConfigEnum.ASSIGNMENT_CONFIG_SHUFFLING
                    )}
                    handleChange={() =>
                      handleToggleSwitch(
                        AssignmentConfigEnum.ASSIGNMENT_CONFIG_SHUFFLING
                      )
                    }
                  />
                </Grid>
              ) : null}
              {conductionConfig.configs.reattempt ? (
                <Grid item xs={12} md={6} lg={4}>
                  <LocalToggle
                    label="Reattempt"
                    checked={checkToggle(
                      AssignmentConfigEnum.ASSIGNMENT_CONFIG_REATTEMPT
                    )}
                    handleChange={() =>
                      handleToggleSwitch(
                        AssignmentConfigEnum.ASSIGNMENT_CONFIG_REATTEMPT
                      )
                    }
                  />
                </Grid>
              ) : null}
              {conductionConfig.configs.timed ? (
                <Grid item xs={12} md={6} lg={4}>
                  <LocalToggle
                    label="Time Test"
                    checked={checkToggle(
                      AssignmentConfigEnum.ASSIGNMENT_CONFIG_TIMED
                    )}
                    handleChange={() =>
                      handleToggleSwitch(
                        AssignmentConfigEnum.ASSIGNMENT_CONFIG_TIMED
                      )
                    }
                  />
                </Grid>
              ) : null}

              {conductionConfig.configs.proctoring ? (
                <Grid item xs={12} md={6} lg={4}>
                  <LocalToggle
                    label="Proctoring"
                    checked={checkToggle(
                      AssignmentConfigEnum.ASSIGNMENT_CONFIG_PROCTORING
                    )}
                    handleChange={() =>
                      handleToggleSwitch(
                        AssignmentConfigEnum.ASSIGNMENT_CONFIG_PROCTORING
                      )
                    }
                    infoNode={<ProctoringInfoNode />}
                  />
                </Grid>
              ) : null}

              {conductionConfig.features.attendance &&
              isAttendanceFeatureEnabled ? (
                <Grid item xs={12} md={6} lg={4}>
                  <LocalToggle
                    label="Attendance"
                    checked={checkToggle(
                      AssignmentConfigEnum.ASSIGNMENT_CONFIG_ATTENDANCE
                    )}
                    handleChange={() =>
                      handleToggleSwitch(
                        AssignmentConfigEnum.ASSIGNMENT_CONFIG_ATTENDANCE
                      )
                    }
                  />
                </Grid>
              ) : null}
            </Grid>
          ) : null}
          {custom_homework?.taskType !==
            TaskEnum.TASK_HOMEWORK_TEACHER_CUSTOM &&
          conductionConfig.configs.questionBasedTimer ? (
            <ClickerTimedToggle
              toggleChecked={checkToggle(
                AssignmentConfigEnum.ASSIGNMENT_CONFIG_QUESTION_BASED_TIMER
              )}
              handleToggleChange={() =>
                handleToggleSwitch(
                  AssignmentConfigEnum.ASSIGNMENT_CONFIG_QUESTION_BASED_TIMER
                )
              }
              clickerTimedType={clickerTimedType}
              handleClickerTimedType={(type) => setClickerTimedType(type)}
              selectedPreDefinedTime={selectedPreDefinedTime}
              handleSelectedPreDefinedTimeChange={(value) =>
                setSelectedPreDefinedTime(value)
              }
              customDefinedTime={customDefinedTime}
              handleCustomDefinedTimeChange={(value) =>
                setCustomDefinedTime(value)
              }
            />
          ) : null}
        </Box>
        <Box>
          {custom_homework?.taskType ===
          TaskEnum.TASK_HOMEWORK_TEACHER_CUSTOM ? (
            <Box
              sx={{ mb: { xs: pxToRem(60), md: 0 }, marginTop: { sx: '50px' } }}
            >
              <InstructionsPanel
                customSx={{
                  display: 'flex',
                  flexGrow: 1,
                  width: { xs: '100%', md: pxTovW(900), lg: pxTovW(555) },
                  padding: { xs: 0, md: pxToRem(20) },
                  // height: pxToRem(450),
                }}
                editIconDisplay
                Katexvalue={custom_homework?.assessmentInstructions?.[0]}
                AttachmentList={custom_homework.taskUploads.filter(
                  (e) => e.isDeleted === false
                )}
                onRedirect={async () => {
                  navigate(-1);
                  await interactionEvent({
                    context: 'instructions',
                    name: 'EDIT',
                    pathSegments: pathSegments,
                    isOffline: isOffline,
                  });
                }}
              />
            </Box>
          ) : conductionConfig.meta.isClicker ? (
            <Box
              sx={{ mb: { xs: pxToRem(60), md: 0 }, marginTop: { sx: '50px' } }}
            >
              <InstructionsPanel
                customSx={{
                  display: 'flex',
                  flexGrow: 1,
                  width: { xs: '100%', md: pxTovW(900), lg: pxTovW(555) },
                  padding: { xs: 0, md: pxToRem(20) },
                  height: '100%',
                  '> div > div > div:last-child': {
                    // backgroundColor: 'red',
                    maxHeight: '100%',
                    height: '100%',
                  },
                }}
                title="Instructions for Teachers:"
                Katexvalue={ClickerAssessmentIntructions}
              />
            </Box>
          ) : (
            <Box sx={styles.instructionBox}>
              <Box sx={styles.instructionCard}>
                <Box
                  sx={{
                    height: '5px',
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    // padding: { md: pxTovW(20) },
                  }}
                >
                  <IconWrapper
                    name="edit"
                    parentFolder="icons"
                    type="png"
                    size="md"
                    customSx={{
                      height: { xs: pxToRem(34), md: pxTovW(34) },
                      width: { xs: pxToRem(34), md: pxTovW(34) },
                      cursor: 'pointer',
                    }}
                    onClick={() => setOpenInstructionsPopup(true)}
                  />
                </Box>
                <Box
                  sx={{
                    ...styles.textBox,
                  }}
                >
                  <Typography variant="h2" fontWeight="bold">
                    Instructions :
                  </Typography>
                </Box>
                {assessment_instructions?.map((elem: string, i: number) => (
                  <Box key={i} sx={styles.textBox}>
                    <Box
                      sx={{
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        cursor: 'pointer',
                      }}
                    >
                      <CheckOutlinedIcon fontSize="small" color="primary" />
                    </Box>
                    <Typography
                      variant={!isMobile && isIpad ? 'h3' : 'h4'}
                      sx={{
                        wordBreak: 'break-word',
                      }}
                    >
                      {elem}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Box>
          )}
        </Box>
        <HomeworkInstructionsPopup
          instructions={assessment_instructions}
          setInstructions={(arr) => dispatch(setAssessmentInstructions(arr))}
          open={openInstructionsPopup}
          handleClose={() => setOpenInstructionsPopup(false)}
        />
      </Box>

      <Box
        sx={{
          display: { xs: 'unset', md: 'none' },
          position: 'fixed',
          top: { md: pxTovW(126) },
          left: { xs: 'unset', md: pxTovW(1450), lg: pxTovW(1279) },
          bottom: { xs: pxToRem(10), md: '100%' },
          width: { xs: '90vw', md: 'max-content' },
        }}
      >
        <PrimaryButton
          key={`assign_${minute}`}
          disabled={
            wrongStartTime({ startTimeValues }).wrongDate ||
            wrongStartTime({ startTimeValues }).wrongTime ||
            wrongEndTime({ startTimeValues, endTimeValues }).wrongDate ||
            wrongEndTime({ startTimeValues, endTimeValues }).wrongTime
          }
          onClick={assignClickHandler}
        >
          Assign
        </PrimaryButton>
        <StudentListPopup
          open={studentListPopupOpen}
          handleClose={() => setStudentListPopupOpen(false)}
          sectionList={sectionList}
          setSectionList={setSectionList}
          handleSectionChange={handleChange}
          sectionStudentInfo={sectionStudentInfo}
          setSectionStudentInfo={setSectionStudentInfo}
        />
      </Box>
    </Box>
  );
};

// -------------------------------------------------------------

const LocalToggle = ({
  label,
  checked,
  handleChange,
  infoNode,
}: {
  label: string;
  checked: boolean;
  handleChange: () => void;
  infoNode?: ReactNode;
}) => {
  return (
    <Grid
      container
      sx={{
        display: 'flex',
        alignItems: 'center',
        // paddingLeft: { xs: pxToRem(10), md: pxTovW(10) },
        paddingY: { xs: pxToRem(10), md: pxTovW(20) },
        boxSizing: 'border-box',
      }}
    >
      <Grid
        item
        xs={7.5}
        md={7.5}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: { xs: pxToRem(10), md: pxTovW(10) },
          // justifyContent: 'flex-start',
          justifyContent: { xs: 'flex-start', md: 'flex-end' },
          // marginBottom: { xs: pxToRem(10), md: pxTovW(10) },
          maxHeight: { xs: pxToRem(16), md: pxTovW(22), lg: pxTovW(16) },
          marginRight: { xs: pxToRem(10), md: pxTovW(10) },
        }}
      >
        <Typography variant="h3" sx={styles.labelTypo}>
          {label}
        </Typography>

        <Box>{infoNode}</Box>
      </Grid>

      <Grid item xs={4} md={4}>
        <ToggleSwitch checked={checked} handleChange={handleChange} />
      </Grid>
    </Grid>
  );
};

// -------------------------------------------------------------

const ProctoringInfoNode = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popper' : undefined;

  const proctoringInfo = [
    'Use Fullscreen Mode',
    'Avoid Switching Tabs',
    'Don’t Try Multiple Sessions',
    'Don’t Keep Device Idle for Too Long',
  ];

  const handleMouseEnter = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMouseLeave = () => {
    setAnchorEl(null);
  };

  return (
    <Box onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <IconWrapper
        name="tooltip-black"
        parentFolder="icons"
        type="png"
        size="small"
        customSx={{
          height: { xs: pxToRem(14), md: pxTovW(20), lg: pxTovW(14) },
          width: { xs: pxToRem(14), md: pxTovW(20), lg: pxTovW(14) },
          cursor: 'pointer',
        }}
      />

      <Popper id={id} open={open} anchorEl={anchorEl} placement="top">
        <Box
          sx={{
            backgroundColor: '#050505',
            color: '#FFFFFF',
            padding: { xs: pxToRem(10), md: pxTovW(10) },
            minWidth: { xs: pxToRem(240), md: pxTovW(240) },
            borderRadius: { xs: pxToRem(10), md: pxTovW(10) },
            marginBottom: { xs: pxToRem(35), md: pxTovW(50) },
            marginLeft: { xs: pxToRem(20), md: pxTovW(0) },
            zIndex: 1000,
            position: 'relative',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              // gap: { xs: pxToRem(16), md: pxTovW(16) },
              border: '1px solid #FFFFFF',
              borderRadius: { xs: pxToRem(16), md: pxTovW(16) },
            }}
          >
            <Typography
              textAlign="center"
              sx={{
                fontWeight: 600,
                fontSize: { xs: pxToRem(16), md: pxTovW(18) },
                padding: { xs: pxToRem(10), md: pxTovW(10) },
              }}
            >
              Proctoring Do’s & Don’ts
            </Typography>

            {proctoringInfo.map((info, index) => (
              <Typography
                key={info}
                sx={{
                  fontSize: { xs: pxToRem(14), md: pxTovW(16) },
                  fontWeight: 600,
                  borderTop: '1px solid #FFFFFF',
                  padding: { xs: pxToRem(10), md: pxTovW(10) },
                }}
              >
                {index + 1}. {info}
              </Typography>
            ))}
          </Box>
        </Box>

        <Box
          sx={{
            width: 0,
            height: 0,
            borderLeft: {
              xs: pxToRem(50) + ' solid transparent',
              md: pxTovW(50) + ' solid transparent',
            },
            borderRight: {
              xs: pxToRem(50) + ' solid transparent',
              md: pxTovW(50) + ' solid transparent',
            },
            borderTop: {
              xs: pxToRem(50 * Math.sqrt(3)) + ' solid #050505',
              md: pxTovW(50 * Math.sqrt(3)) + ' solid #050505',
            }, // x * √3, for equilateral proportions
            position: 'absolute',
            left: { xs: '35%', md: '35%' },
            bottom: { xs: pxToRem(10), md: pxTovW(20) },
            margin: 'auto',
          }}
        ></Box>
      </Popper>
    </Box>
  );
};

// -------------------------------------------------------------

const initialToggleData = [
  {
    configName: AssignmentConfigEnum.ASSIGNMENT_CONFIG_REATTEMPT,
    isEnabled: true,
  },
  {
    configName: AssignmentConfigEnum.ASSIGNMENT_CONFIG_SHUFFLING,
    isEnabled: true,
  },
  {
    configName: AssignmentConfigEnum.ASSIGNMENT_CONFIG_TIMED,
    isEnabled: false,
  },
  {
    configName: AssignmentConfigEnum.ASSIGNMENT_CONFIG_ALLOW_LATE_SUBMISSION,
    isEnabled: false,
  },
  {
    configName: AssignmentConfigEnum.ASSIGNMENT_CONFIG_QUESTION_BASED_TIMER,
    isEnabled: false,
  },
  {
    configName: AssignmentConfigEnum.ASSIGNMENT_CONFIG_PROCTORING,
    isEnabled: false,
  },
  {
    configName: AssignmentConfigEnum.ASSIGNMENT_CONFIG_ATTENDANCE,
    isEnabled: false,
  },
];

const exampleSectionList = [
  {
    name: 'A',
    id: 1,
    selected: true,
  },
  {
    name: 'B',
    id: 2,
    selected: true,
  },
  {
    name: 'C',
    id: 3,
    selected: true,
  },
];

const ClickerAssessmentIntructions =
  "<p>When you click on <strong>'Assign'</strong>, a test will be created and will appear under the ‘Active Clicker Assessments’ section on your homepage.</p>   <p>Since this is a <strong>clicker-based assessment</strong>, please ensure that the session is conducted in a <strong>connected classroom setup </strong>that supports clickers.</p>   <p>To conduct the assessment, follow these steps:</p>    <p>1. <strong>Distribute clickers</strong> to all students.</p>    <p>2. <strong>Click on assessment card</strong> you wish to conduct the test for - from the ‘Active Clicker Assessments’ section.</p>     <p>3. <strong>'Start'</strong> the assessment when ready.</p>";
